/*
 * @Description:
 * @Version: 2.0
 * @Autor: Lianzhidong
 * @Date: 2021-12-04 13:51:00
 * @LastEditors: Lianzhidong
 * @LastEditTime: 2022-01-23 14:58:19
 */
const getters = {
  sidebar: (state) => state.app.sidebar,
  device: (state) => state.app.device,
  token: (state) => state.user.token,
  refreshToken: (state) => state.user.refreshToken,
  avatar: (state) => state.user.avatar,
  name: (state) => state.user.name,
};
export default getters;
